import { useFormState } from "common/hooks";
import { FetchError, AllFieldErrors } from "common/fetch/types";
import { Optional } from "common/utils/types";

import TextInput from "client/common/components/inputs/TextInput";
import DrawerLayout from "client/common/components/stackables/DrawerLayout";
import PhoneInput from "client/common/components/inputs/PhoneInput";

type FormValues = {
  email: string;
  first_name: string;
  last_name: string;
  /* TODO: [sc-41928] remove 'phone_number' as this is temporary fix */
  phone_number: string;
};
type AccountFormProps = {
  initialValues: FormValues;
  onSubmit: (values: FormValues) => void;
  submitText: string;
  isLoading: boolean;
  error: Optional<FetchError>;
  fieldErrors: Optional<AllFieldErrors<FormValues>>;
  /* TODO: [sc-41928] remove 'updatePhoneNumber' as this is temporary fix */
  updatePhoneNumber: boolean;
};

const AccountForm = ({
  initialValues,
  onSubmit,
  submitText,
  isLoading,
  error,
  fieldErrors,
  /* TODO: [sc-41928] remove 'updatePhoneNumber' as this is temporary fix */
  updatePhoneNumber,
}: AccountFormProps) => {
  const [values, updateField] = useFormState(initialValues);

  return (
    <DrawerLayout.Form
      submitText={submitText}
      canSubmit={!isLoading}
      onSubmit={() => onSubmit(values)}
      isLoading={isLoading}
      error={error}
    >
      <DrawerLayout.Form.Group>
        <TextInput
          value={values.first_name}
          label="First Name"
          onChange={updateField("first_name")}
          errors={fieldErrors?.first_name}
        />
      </DrawerLayout.Form.Group>
      <DrawerLayout.Form.Group>
        <TextInput
          value={values.last_name}
          label="Last Name"
          onChange={updateField("last_name")}
          errors={fieldErrors?.last_name}
        />
      </DrawerLayout.Form.Group>
      <DrawerLayout.Form.Group>
        <TextInput
          value={values.email}
          label="Email Address"
          onChange={updateField("email")}
          errors={fieldErrors?.email}
        />
      </DrawerLayout.Form.Group>
      {/* TODO: [sc-41928] remove this phone number update as this is temporary fix */}
      {updatePhoneNumber && (
        <DrawerLayout.Form.Group>
          <PhoneInput
            value={values.phone_number}
            label="Phone Number"
            onChange={updateField("phone_number")}
            errors={fieldErrors?.phone_number}
          />
        </DrawerLayout.Form.Group>
      )}
    </DrawerLayout.Form>
  );
};

export default AccountForm;
